import styled from 'styled-components';

export const FilterWrapper = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }

  & > div:first-child {
    margin-bottom: 12px;
  }
`;
